import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Platform,
  Modal as RNModal,
} from "react-native";
import { FontAwesome5, Ionicons } from "@expo/vector-icons";
import DateTimePicker from "@react-native-community/datetimepicker";
import { DatePickerModal } from "react-native-paper-dates";
import moment from "moment";
import Modal from "react-native-modal";
import { Row } from "./all";
import { normalize } from "../utils/normalize";

const DatePostedSelect = (props) => {
  const [showDatepicker, setShowDatepicker] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);
  const [showCustomPicker, setShowCustomPicker] = useState(false);
  const [datePickerMode, setDatePickerMode] = useState("start"); // "start" or "end"

  const presetOptions = [
    { label: "Last 30 days", days: 30 },
    { label: "Last 60 days", days: 60 },
    { label: "Last 90 days", days: 90 },
  ];

  useEffect(() => {
    // If value is provided (edit mode), determine which preset it matches
    if (props.value && props.value.created_min) {
      const startMoment = moment(props.value.created_min);
      const endMoment = props.value.created_max ? moment(props.value.created_max) : moment();
      const daysDiff = moment().diff(startMoment, "days");

      const matchingPreset = presetOptions.find(
        (option) => Math.abs(daysDiff - option.days) <= 1
      );

      if (matchingPreset) {
        setSelectedOption(matchingPreset);
      } else {
        setSelectedOption({ label: "Custom", days: null });
        setCustomStartDate(new Date(props.value.created_min));
        if (props.value.created_max) {
          setCustomEndDate(new Date(props.value.created_max));
        }
      }
    }
  }, [props.value]);

  const handlePresetSelect = (option) => {
    setSelectedOption(option);
    const endDate = moment().endOf("day").valueOf(); // End of today
    const startDate = moment().subtract(option.days, "days").startOf("day").valueOf();
    
    props.onChange && props.onChange({
      created_min: startDate,
      created_max: endDate
    });
    setShowDatepicker(false);
  };

  const handleCustomSelect = () => {
    setShowDatepicker(false);
    setSelectedOption({ label: "Custom", days: null });
    setDatePickerMode("start");
    setTimeout(() => {
      setShowCustomPicker(true);
    }, 1000);
  };

  const onChangeCustomDate = (event, selectedDate) => {
    if (Platform.OS === "android") {
      setShowCustomPicker(false);
    }

    if (selectedDate) {
      if (datePickerMode === "start") {
        setCustomStartDate(selectedDate);
        if (Platform.OS === "android") {
          // On Android, show end date picker after start date is selected
          setTimeout(() => {
            setDatePickerMode("end");
            setShowCustomPicker(true);
          }, 500);
        }
      } else {
        setCustomEndDate(selectedDate);
        // Update the value when both dates are selected
        if (customStartDate) {
          const endOfDay = moment(selectedDate).endOf("day").valueOf();
          const startOfDay = moment(customStartDate).startOf("day").valueOf();
          props.onChange && props.onChange({
            created_min: startOfDay,
            created_max: endOfDay
          });
        }
      }
    }
  };

  const onConfirmCustomDate = () => {
    setShowCustomPicker(false);
    if (customStartDate && customEndDate) {
      const endOfDay = moment(customEndDate).endOf("day").valueOf();
      const startOfDay = moment(customStartDate).startOf("day").valueOf();
      props.onChange && props.onChange({
        created_min: startOfDay,
        created_max: endOfDay
      });
    }
  };

  const getDisplayText = () => {
    if (!selectedOption) {
      return props.placeholder || "Select Date Posted";
    }

    if (selectedOption.days === null) {
      // Custom date range
      if (customStartDate && customEndDate) {
        return `${moment(customStartDate).format("DD MMM")} - ${moment(customEndDate).format("DD MMM YYYY")}`;
      } else if (props.value && props.value.created_min) {
        return `${moment(props.value.created_min).format("DD MMM")} - ${moment(props.value.created_max || Date.now()).format("DD MMM YYYY")}`;
      }
      return "Select Date Range";
    }

    // Preset option
    const startDate = moment().subtract(selectedOption.days, "days");
    const endDate = moment();
    return `${selectedOption.label} (${startDate.format("DD MMM")} - ${endDate.format("DD MMM")})`;
  };

  const renderPresetOptions = () => (
    <Modal
      isVisible={showDatepicker}
      onBackdropPress={() => setShowDatepicker(false)}
      style={{ margin: 0, justifyContent: "flex-end" }}
    >
      <View
        style={{
          backgroundColor: "white",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          paddingTop: 20,
          paddingBottom: 40,
        }}
      >
        <View
          style={{
            borderBottomWidth: 1,
            borderBottomColor: "#E5E5E5",
            paddingBottom: 16,
            marginHorizontal: 24,
          }}
        >
          <Text
            style={{
              fontSize: normalize(18),
              fontWeight: "600",
              textAlign: "center",
            }}
          >
            Select Date Posted
          </Text>
        </View>

        <View style={{ paddingHorizontal: 24, marginTop: 20 }}>
          {presetOptions.map((option, index) => (
            <TouchableOpacity
              key={index}
              onPress={() => handlePresetSelect(option)}
              style={{
                paddingVertical: 16,
                borderBottomWidth: 1,
                borderBottomColor: "#F0F0F0",
              }}
            >
              <Row style={{ justifyContent: "space-between" }}>
                <Text
                  style={{
                    fontSize: normalize(16),
                    color: "#333",
                  }}
                >
                  {option.label}
                </Text>
                <Text
                  style={{
                    fontSize: normalize(14),
                    color: "#666",
                  }}
                >
                  {moment().subtract(option.days, "days").format("DD MMM")} - {moment().format("DD MMM")}
                </Text>
              </Row>
            </TouchableOpacity>
          ))}

          <TouchableOpacity
            onPress={handleCustomSelect}
            style={{
              paddingVertical: 16,
              borderBottomWidth: 1,
              borderBottomColor: "#F0F0F0",
            }}
          >
            <Row centered>
              <Ionicons name="calendar-outline" size={20} color="#4B9BFF" />
              <Text
                style={{
                  fontSize: normalize(16),
                  color: "#4B9BFF",
                  marginLeft: 8,
                }}
              >
                Choose Custom Date Range
              </Text>
            </Row>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );

  const renderCustomDatePicker = () => {
    if (Platform.OS === "web") {
      return (
        <RNModal
          visible={showCustomPicker}
          transparent={true}
          animationType="fade"
          onRequestClose={() => setShowCustomPicker(false)}
        >
          <TouchableOpacity
            style={{
              flex: 1,
              backgroundColor: "rgba(0,0,0,0.5)",
              justifyContent: "center",
              alignItems: "center",
            }}
            activeOpacity={1}
            onPress={() => setShowCustomPicker(false)}
          >
            <View
              style={{
                backgroundColor: "white",
                borderRadius: 12,
                padding: 20,
                width: 350,
              }}
            >
              <Text
                style={{
                  fontSize: normalize(16),
                  fontWeight: "600",
                  marginBottom: 16,
                  textAlign: "center",
                }}
              >
                Select Date Range
              </Text>
              <DatePickerModal
                locale="en"
                mode="range"
                visible={true}
                onDismiss={() => setShowCustomPicker(false)}
                startDate={customStartDate}
                endDate={customEndDate}
                onConfirm={(params) => {
                  if (params.startDate && params.endDate) {
                    setCustomStartDate(params.startDate);
                    setCustomEndDate(params.endDate);
                    const endOfDay = moment(params.endDate).endOf("day").valueOf();
                    const startOfDay = moment(params.startDate).startOf("day").valueOf();
                    props.onChange && props.onChange({
                      created_min: startOfDay,
                      created_max: endOfDay
                    });
                  }
                  setShowCustomPicker(false);
                }}
                validRange={{
                  startDate: moment().subtract(1, "year").toDate(),
                  endDate: new Date(),
                }}
              />
            </View>
          </TouchableOpacity>
        </RNModal>
      );
    }

    if (Platform.OS === "ios") {
      return (
        <Modal
          isVisible={showCustomPicker}
          onBackdropPress={() => setShowCustomPicker(false)}
          style={{ margin: 0, justifyContent: "flex-end" }}
        >
          <View
            style={{
              backgroundColor: "white",
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              paddingBottom: 40,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 16,
                borderBottomWidth: 1,
                borderBottomColor: "#E5E5E5",
              }}
            >
              <TouchableOpacity
                onPress={() => setShowCustomPicker(false)}
                style={{ padding: 8 }}
              >
                <Text style={{ fontSize: normalize(16), color: "#333" }}>
                  Cancel
                </Text>
              </TouchableOpacity>
              <Text style={{ fontSize: normalize(16), fontWeight: "600" }}>
                {datePickerMode === "start" ? "Select Start Date" : "Select End Date"}
              </Text>
              <TouchableOpacity
                onPress={() => {
                  if (datePickerMode === "start" && customStartDate) {
                    setDatePickerMode("end");
                  } else {
                    onConfirmCustomDate();
                  }
                }}
                style={{ padding: 8 }}
              >
                <Text style={{ fontSize: normalize(16), color: "#333" }}>
                  {datePickerMode === "start" && customStartDate ? "Next" : "Done"}
                </Text>
              </TouchableOpacity>
            </View>
            
            {customStartDate && customEndDate && (
              <View style={{ padding: 16, backgroundColor: "#F5F5F5" }}>
                <Text style={{ fontSize: normalize(14), textAlign: "center", color: "#666" }}>
                  {moment(customStartDate).format("DD MMM YYYY")} - {moment(customEndDate).format("DD MMM YYYY")}
                </Text>
              </View>
            )}
            
            <View style={{
              justifyContent: "center",
              alignItems: "center",
            }}>
              <DateTimePicker
                value={datePickerMode === "start" ? (customStartDate || new Date()) : (customEndDate || customStartDate || new Date())}
                mode="date"
                display="inline"
                onChange={onChangeCustomDate}
                minimumDate={datePickerMode === "start" ? moment().subtract(1, "year").toDate() : (customStartDate || moment().subtract(1, "year").toDate())}
                maximumDate={new Date()}
                textColor="black"
                themeVariant="light"
                style={{ backgroundColor: "white" }}
              />
            </View>
          </View>
        </Modal>
      );
    }

    // Android
    return (
      showCustomPicker && (
        <DateTimePicker
          value={datePickerMode === "start" ? (customStartDate || new Date()) : (customEndDate || customStartDate || new Date())}
          mode="date"
          display="default"
          onChange={onChangeCustomDate}
          minimumDate={datePickerMode === "start" ? moment().subtract(1, "year").toDate() : (customStartDate || moment().subtract(1, "year").toDate())}
          maximumDate={new Date()}
        />
      )
    );
  };

  return (
    <View style={props.style}>
      <TouchableOpacity
        onPress={() => setShowDatepicker(true)}
        style={{
          flexDirection: "row",
          alignItems: "center",
          borderWidth: 1,
          borderColor: props.error ? "red" : "#E5E5E5",
          borderRadius: 8,
          paddingHorizontal: 16,
          paddingVertical: Platform.OS === "ios" ? 16 : 14,
          backgroundColor: "white",
        }}
      >
        <FontAwesome5 name="calendar-alt" size={14} color="grey" />
        <Text
          style={{
            flex: 1,
            marginLeft: 12,
            fontSize: normalize(14),
            color: selectedOption ? "#333" : "#999",
          }}
        >
          {getDisplayText()}
        </Text>
        <Ionicons name="chevron-down" size={20} color="#666" />
      </TouchableOpacity>

      {renderPresetOptions()}
      {renderCustomDatePicker()}
    </View>
  );
};

export default DatePostedSelect;